export default __webpack_public_path__ + "static/media/schedule-available_blue.c847505b.svg";